// extracted by mini-css-extract-plugin
export default {"logOutModal":"styles_logOutModal__SGehb","text":"styles_text__8NKvk"};